import appConfig from '@/config/global-config'
import { getCookies, removeCookiesToken } from '@/libs/cookies'
import { useAccountStore, useCartStore } from '@/store'
type CustomOptions = RequestInit & {
  baseUrl?: string | undefined
  locale?: string
  next?: NextFetchRequestConfig
}

class HttpError extends Error {
  status: number
  payload: any
  constructor({ status, payload }: { status: number; payload: any }) {
    super()
    this.name = 'HttpError'
    this.status = status
    this.payload = payload
  }
}

// const pendingRequests = []

// function handleLoginSuccess() {
//   for (const request of pendingRequests) {
//       fetcher[request.method](request.url, request.options, request.body) // Retry each request
//           .then(response => {
//               // Handle successful response (optional)
//           })
//           .catch(error => {
//               // Handle retries/errors (optional)
//           });
//   }

//   pendingRequests = []; // Clear the queue after retries
// }

const isLogin = (message: string, match: string[]) => {
  return match.some((item) => message?.toLowerCase()?.includes(item))
}

export const request = async <Response>(
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  url: string,
  option?: CustomOptions
) => {
  const body = option?.body ? JSON.stringify(option.body) : undefined
  const baseHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
  }
  //nếu không truyền baseUrl thì lấy từ .env
  const baseUrl = option?.baseUrl === undefined ? process.env.NEXT_PUBLIC_API_URL : option.baseUrl
  const locale = option?.locale || (await getCookies('locale')) || appConfig.defaultLocale
  const fullUrl = url.startsWith('/') ? `${baseUrl}${url}` : `${baseUrl}/${url}`

  const { next, cache, ...restOptions } = option || {}

  const res = await fetch(fullUrl, {
    method,
    headers: {
      ...baseHeaders,
      // ...option?.headers,
      ...restOptions?.headers,
      Store: locale,
    },
    body,
    next,
    cache,
  })
  // console.log('refetch', fullUrl)

  let payload: Response | any
  try {
    payload = await res.json()
  } catch (error) {
    // Handle cases where response is not valid JSON
    payload = { error: 'Invalid JSON response' }
  }

  const data = {
    status: res.status,
    payload,
  }

  if (
    isLogin(payload?.errors?.[0]?.message, ['authorization', 'authorized', 'authorization']) ||
    isLogin(payload?.errors?.[0]?.extensions?.category, ['authorization', 'authorized', 'authorization'])
  ) {
    const isLoginRequired =
      payload?.errors?.[0]?.message?.includes(
        'Đơn hàng này được mua bằng tài khoản. Vui lòng đăng nhập để đánh giá.'
      ) || false

    if (!isLoginRequired) {
      // pendingRequests.push({ method, url, options: option, body });
      removeCookiesToken()
      // removeRefCookies()
      useAccountStore.getState().clearUser()
      useCartStore.getState().clearCart()
      // data.payload.errors = [{ debugMessage: 'Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại' }]
      // useCommonStore.getState().setNoti("Login session expired, please login to continue", "info")
    }
  }
  if (!res.ok) {
    throw new HttpError(data)
  }
  return data
}

const fetcher = {
  get: <Response>(url: string, options?: Omit<CustomOptions, 'body'> | undefined) =>
    request<Partial<Response>>('GET', url, options),
  post: <Response>(url: string, body: any, options?: Omit<CustomOptions, 'body'> | undefined) =>
    request<Partial<Response>>('POST', url, { ...options, body }),
  put: <Response>(url: string, body: any, options?: Omit<CustomOptions, 'body'> | undefined) =>
    request<Partial<Response>>('PUT', url, { ...options, body }),
  delete: <Response>(url: string, body: any, options?: Omit<CustomOptions, 'body'> | undefined) =>
    request<Partial<Response>>('DELETE', url, { ...options, body }),
}

export default fetcher

import { getCookieToken } from '@/libs/cookies'

/**
 * This function no cache by default
 */
export const fetchWithToken = async <Response>(
  body: any,
  options?: Omit<CustomOptions, 'body'> | undefined
) => {
  const cookies = await getCookieToken()
  const fbp = await getCookies('_fbp')
  const fbc = await getCookies('_fbc')
  const authorizationHeader = cookies ? `Bearer ${cookies}` : ''
  const newOptions = {
    ...options,
    headers: { ...options?.headers, Authorization: authorizationHeader, fbp: fbp || '', fbc: fbc || '' },
  }
  return request<Partial<Response>>('POST', '', { ...newOptions, body })
}

export const mutateGraphQL = <Response>(body: any, options?: Omit<CustomOptions, 'body'> | undefined) => {
  return request<Partial<Response>>('POST', '', { ...options, body })
}
